'use strict';

import dialog from './dialog';
import util from './util';

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
export default function () {
    /**
     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
     */
    var $cookieSlot = $('.cookies-slot');
	
    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
        	$cookieSlot.show().on('click', '.cookie-agree-button', function(){
        		$cookieSlot.hide();
        		enableCookies();
        		
        	})
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
    	$cookieSlot.hide();
        enableCookies();
    }

    function enableCookies() {
        if (document.cookie.indexOf('dw=1') < 0) {
            document.cookie = 'dw=1; path=/';
        }
        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
            document.cookie = 'dw_cookies_accepted=1; path=/';            
           
            //cookie consent for newsletter pop in        		
   	     util.setCookie(Constants.COOKIENAME_COOKIECONSENT_FLAG, true, newsletterCookieDuration);
        }
    }
    
    // cookies policy close button functionality
    $cookieSlot.on('click', '.close-icon', function(){
    	$cookieSlot.hide();
    	 //cookie consent for newsletter pop in        		
  	     util.setCookie(Constants.COOKIENAME_COOKIECONSENT_FLAG, false, newsletterCookieDuration);
    })
};
